import React from "react";
import { useNavigate } from "react-router-dom";
import "./ThankYouPopup.css";

const ThankYouPopup = ({ show, onClose }) => {
  const navigate = useNavigate();

  if (!show) return null;

  return (
    <div className="thankyou-overlay">
      <div className="thankyou-modal">
        
        <div className="check-icon">
          ✓
        </div>

        <h3>Thank you for your order</h3>

        <p>Your order was placed successfully.</p>
        <p>For more details, check your orders</p>

        <button className="done-btn" onClick={() => { onClose(); navigate('/'); }}>
          Done
        </button>

      </div>
    </div>
  );
};

export default ThankYouPopup;